// extracted by mini-css-extract-plugin
export default {"wrapper":"h7-z"};